<template>
  <section
    v-if="exam.failed"
    class="container is-full is-greyish align-vertical is-centered pb-5"
  >
    <h1 class="title huge-title mt-1 has-text-danger">
      <i class="fa fa-exclamation-circle fa-3x" />
    </h1>
    <h1 class="has-text-warning huge-title" v-html="$t('exam.exam-failed')" />
    <div class="subtitle is-4">
      <p
        v-html="
          $t('exam.last-attempt-results', {
            results: exam.result_percents,
            pass_rate: exam.pass_rate,
          })
        "
      />

      <a
        :href="exam.next_url"
        class="button is-primary is-large mt-2"
        v-html="$t('exam.proceed')"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: 'Failed',

  props: {
    exam: { type: Object, required: true }
  }
};
</script>
